import { useAuth } from "react-oidc-context";
import { organizationSchema } from "@medoma/models/organizations";
import { z } from "zod";

const userProfileSchema = z.object({
  // The auth service names the organization claim `unit`.
  unit: organizationSchema,
});

export const useUserProfile = () => {
  const { user } = useAuth();
  if (!user) {
    throw new Error(
      "No user found. This is usually because the hook is executed outside of an AuthProvider, or because the authentication is not completed yet.",
    );
  }

  const { unit: organization } = userProfileSchema.parse(user.profile, {
    error: () =>
      "Malformed or missing 'unit'. Did you forget the 'organization' scope?",
  });

  return { organization };
};
